import { render, staticRenderFns } from "./GetToken.vue?vue&type=template&id=0c40f99c"
import script from "./GetToken.vue?vue&type=script&lang=ts"
export * from "./GetToken.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports